import { color } from '@hubble/tokens/web';

const DARK = 'dark';
const LIGHT = 'light';
const LIGHT_V2 = 'light-v2';
const DARK_V2 = 'dark-v2';
const MARS = 'mars';
function getTheme(scheme, parentTheme, inverse, locale) {
  let isDark = scheme === DARK || scheme === DARK_V2 || scheme === MARS;
  if (inverse) {
    if ('isDark' in parentTheme && typeof parentTheme.isDark === 'boolean') {
      isDark = !parentTheme.isDark;
    } else {
      console.error('`inverse` can only be used with nested ThemeProviders');
    }
  }
  if (!locale && !('translate' in parentTheme)) {
    console.error('HubbleProvider: The `locale` prop in the top-level `HubbleProvider` must be defined.');
    return;
  }
  function getColorScheme(scheme) {
    switch (scheme) {
      case LIGHT:
        return color.lightMode;
      case DARK:
        return color.darkMode;
      case LIGHT_V2:
        return color.lightModeV2;
      case DARK_V2:
        return color.darkModeV2;
      case MARS:
        return color.mars;
      default:
        return color.lightMode;
    }
  }
  return {
    colorScheme: getColorScheme(scheme),
    isDark,
    scheme,
    translate: 'translate' in parentTheme && typeof parentTheme.translate === 'function' ? parentTheme.translate : (path, replacements) => {
      const translation = get(locale, path);
      if (!translation) {
        console.error(`HubbleProvider: No translation found for ${path}`);
      }
      if (typeof translation === 'string') {
        return translation;
      } else if (typeof translation === 'function') {
        return translation(replacements);
      }
    }
  };
}
const OBJECT_NOTATION_MATCHER = /\[(.*?)\]|(\w+)/g;
function get(obj, keypath, defaultValue) {
  if (obj == null) return undefined;
  const keys = Array.isArray(keypath) ? keypath : getKeypath(keypath);
  let acc = obj;
  for (let i = 0; i < keys.length; i++) {
    const val = acc[keys[i]];
    if (val === undefined) return defaultValue;
    acc = val;
  }
  return acc;
}
function getKeypath(str) {
  const path = [];
  let result;
  while (result = OBJECT_NOTATION_MATCHER.exec(str)) {
    const [, first, second] = result;
    path.push(first || second);
  }
  return path;
}

export { get, getTheme };
